import {
    getOrderApprovalsDataView,
    getOrderApprovalsState,
    OrderApprovalsDataViewContext,
    OrderApprovalsStateContext,
} from "@insite/client-framework/Store/Data/OrderApprovals/OrderApprovalsSelectors";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";
import { useContext } from "react";

export const useOrderApprovalsState = convertSelectorToHook(getOrderApprovalsState);
export const useOrderApprovalsDataView = convertSelectorToHook(getOrderApprovalsDataView);
export const useOrderApprovalsDataViewContext = () => useContext(OrderApprovalsDataViewContext);
export const useOrderApprovalsStateContext = () => useContext(OrderApprovalsStateContext);
